import { render } from "./addinformation.vue?vue&type=template&id=a75bff80&scoped=true"
import script from "./addinformation.vue?vue&type=script&lang=js"
export * from "./addinformation.vue?vue&type=script&lang=js"

import "./addinformation.vue?vue&type=style&index=0&id=a75bff80&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a75bff80"]])

export default __exports__